import store from 'store';
import { ACTIVE_QUESTION, ACTIVE_QUIZ_SESSION_CHANGE, BACKTRACKING_NEXT_QUESTION, CACHED_SESSION_ID, PREVIOUS_QUESTION, SET_CURRENT_SESSION_ITEM_POSITION, PERSIST_PRINT_FONT_SIZE_PREFERENCE, QUIZ_PRINT_FONT_SIZE_PREFERENCE } from '@instructure/quiz-common';
import { sessionStore } from '../util/sessionStore';

/**
 * Some of our redux store values are stored in browser client-side storage
 * for easy recall in the event of a page refresh, etc. This provides a single
 * place to save all of those values so we can know how our data is organized
 * in client-side storage.
 *
 * See also src/common/util/persistedState.js for how these values are loaded.
 */

var persistTakingInfo = function persistTakingInfo(store, persistedLocalStore) {
  var position = store.getState().getIn(['taking', 'currentSessionItemPosition']);
  var sessionId = store.getState().getIn(['quizSessions', 'activeQuizSessionId']);
  persistedLocalStore.set(ACTIVE_QUESTION, position);
  persistedLocalStore.set(CACHED_SESSION_ID, sessionId);
};
var persistPrintFontSizePreference = function persistPrintFontSizePreference(store, persistedLocalStore) {
  var fontSize = store.getState().getIn(['printing', 'fontSizePreference']);
  persistedLocalStore.set(QUIZ_PRINT_FONT_SIZE_PREFERENCE, fontSize);
};
var persistedStorageMiddleware = function persistedStorageMiddleware() {
  var persistedSessionStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sessionStore;
  var persistedLocalStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : store;
  return function (store) {
    return function (next) {
      return function (action) {
        var nextState = next(action);
        if (persistedLocalStore.enabled) {
          switch (action.type) {
            case ACTIVE_QUIZ_SESSION_CHANGE:
            case BACKTRACKING_NEXT_QUESTION:
            case PREVIOUS_QUESTION:
            case SET_CURRENT_SESSION_ITEM_POSITION:
              persistTakingInfo(store, persistedLocalStore);
              break;
            case PERSIST_PRINT_FONT_SIZE_PREFERENCE:
              persistPrintFontSizePreference(store, persistedLocalStore);
              break;
          }
        }
        return nextState;
      };
    };
  };
};
export default persistedStorageMiddleware;